import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { SearchInput } from '../../Core/PathItems'
import { Published } from '../Core/PathItems'

export class CreateSport extends RequestOperation<CreateSportInput,Sport> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.CreateSport",
      "CREATE",
      ["SportId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class SearchSport extends RequestOperation<SearchInput,Sport[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.SearchSport",
      "SEARCH",
      ["SportId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetSport extends RequestOperation<object,Sport> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.GetSport",
      "GET",
      ["SportId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteSport extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.DeleteSport",
      "DELETE",
      ["SportId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateSportName extends MessageOperation<UpdateSportNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.UpdateSportName",
      "PATCH",
      ["SportId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateSportState extends MessageOperation<UpdateSportStateInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.UpdateSportState",
      "PATCH",
      ["SportId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type CreateSportInput = {
  sportId?: string | undefined
  name: string
}

export type Sport = {
  id: string
  name: string
  translationKey: string
  state: Published
}

export type UpdateSportNameInput = {
  name: string
}

export type UpdateSportStateInput = {
  /**
   * Valid values: publish, unpublish, revert
   */
  stateTransition: string
}

